import script from "./partner.vue?vue&type=script&setup=true&lang=js"
export * from "./partner.vue?vue&type=script&setup=true&lang=js"

import "./partner.vue?vue&type=style&index=0&id=6b9f2168&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b9f2168"]])

export default __exports__